<template>
  <tr
    ref="tableRow"
    class="tr-values vs-table--tr"
    :class="[
      `tr-table-state-${state}`,
      {
        'is-selected': isSelected,
        selected: Boolean(data),
        'is-expand': expanded || Boolean(editContent),
        activeEdit: Boolean(editContent),
        hoverFlat: vsTable.hoverFlat,
        'tr-expandedx': expanded || Boolean(editContent),
      },
    ]"
    @dblclick="doubleClickRow"
    @click="clickRow"
  >
    <td
      v-if="vsTable.multiple || hasExpandSlot"
      class="td-check"
      :class="{ 'active-expanded': expanded }"
      @click.stop="handleControlClick"
    >
      <vs-checkbox
        v-if="vsTable.multiple"
        :model-value="isSelected"
        size="small"
        @change="handleCheckbox"
      />
      <vs-icon v-if="hasExpandSlot">keyboard_arrow_down</vs-icon>
    </td>
    <slot />
  </tr>
  <transition name="tr-expand">
    <tr v-if="expanded || editContent" class="tr-expand">
      <td :colspan="colspan">
        <div class="content-tr-expand">
          <slot v-if="expanded" name="expand" />
          <component :is="editContent" v-else />
          <button
            v-if="editContent"
            class="tr-expand--close"
            @click="closeEdit"
          >
            <i class="material-icons">clear</i>
          </button>
        </div>
      </td>
    </tr>
  </transition>
</template>

<script>
import { markRaw } from "vue";

export default {
  name: "VsTr",
  inject: ["vsTable"],
  props: {
    state: {
      type: String,
      default: null,
    },
    data: {
      default: null,
    },
  },
  provide() {
    return {
      vsTableRow: this,
    };
  },
  data() {
    return {
      expanded: false,
      editContent: null,
    };
  },
  computed: {
    hasExpandSlot() {
      return Boolean(this.$slots.expand);
    },
    colspan() {
      return this.vsTable.columnCount;
    },
    isSelected() {
      const selected = this.vsTable.selectedValue;
      if (this.vsTable.multiple && Array.isArray(selected)) {
        return this.data
          ? selected.some(
              (item) => JSON.stringify(item) === JSON.stringify(this.data)
            )
          : false;
      }
      return this.data ? selected === this.data : false;
    },
  },
  watch: {
    "vsTable.displayData"() {
      this.expanded = false;
      this.editContent = null;
    },
  },
  created() {
    if (this.hasExpandSlot) this.vsTable.registerExpandableRow();
  },
  methods: {
    handleCheckbox() {
      this.vsTable.handleCheckbox(this.data);
    },
    handleControlClick() {
      if (this.hasExpandSlot && !this.vsTable.multiple) {
        this.expanded = !this.expanded;
      }
    },
    clickRow() {
      this.vsTable.clickRow(this.data);
      if (this.hasExpandSlot && !this.vsTable.multiple) {
        this.expanded = !this.expanded;
      }
    },
    doubleClickRow() {
      this.vsTable.doubleClickRow(this.data);
    },
    openEdit(slot) {
      this.editContent = markRaw({
        name: "VsTableEditContent",
        render: slot,
      });
    },
    closeEdit() {
      this.editContent = null;
    },
  },
};
</script>
